module.exports = __webpack_public_path__ + "img/bj.c81e8915.svg";